<div class="wrapper animated fadeIn">
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_usuarios.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Usuarios</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Usuarios</h4>
                </div>
            </div>
        </div>
        <br />
        <app-user [add]="add" (added)="onChangeAdd($event)" [edit]="edit">
        </app-user>
        <!-- <app-user-list (added)="onChangeAdd($event)" (editId)="onChangeEdit($event)" (rowSelected)="onRowSelected($event)" [edit]="edit" [add]="add">
        </app-user-list> -->
        <!-- USERLIST -->
        <br />
        <div class="row animated fadeIn" [hidden]="add || edit">
            <div class="col-4">
                <button (click)="changeAdd(true)" class="btn btn-primary mr-2">{{"botones.AgregarUsuario" | translate}}</button>
            </div>
            <div class="col-12">
                <div class="card-box table-responsive">
                    <table datatable [dtOptions]="dtOptions" class="table table-hover m-0 nowrap" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Acciones</th>
                                <th>{{ "usuarios.tablaUsuario.Nombre" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.NumeroDocumento" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.CorreoElectronico" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.FechaUltimoIngreso" | translate }}</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="listUsers?.length != 0">
                            <tr *ngFor="let user of listUsers; let i = index">
                                <td>
                                    <div class="btn-group dropdown">
                                        <button class="table-action-btn dropdown-toggle arrow-none btn btn-light btn-sm" data-bs-toggle="dropdown" aria-expanded="false"><i class="mdi mdi-dots-horizontal"></i></button>
                                        <!-- <a href="#" class="table-action-btn dropdown-toggle arrow-none btn btn-light btn-sm" data-toggle="dropdown" aria-expanded="false"><i class="mdi mdi-dots-horizontal"></i></a> -->
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item btn btn-sm btn-purple" (click)="loadUser(user.idSegUsuario)"><i class="mdi mdi-file-document-box mr-2 vertical-middle"></i>Editar</a>
                                            <a class="dropdown-item btn btn-sm btn-purple" (click)="loadUser(user.idSegUsuario)"><i class="mdi mdi-file-document-box mr-2 vertical-middle"></i>Consultar Roles y Empresas</a>
                                        </div>
                                    </div>
                                </td>
                                <td class="font-w600">{{user.nombre}}</td>
                                <td><span class="label label-danger">{{user.numeroDocumento}}</span> </td>
                                <td><span class="label label-danger">{{user.correoElectronico}}</span></td>
                                <td class="hidden-xs"> <em class="text-muted">{{user.fechaCreacion | date:"short"}}</em></td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="listUsers?.length == 0">
                            <tr>
                                <td colspan="3" class="no-data-available">No data!</td>
                            </tr>
                            <tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="blanco"></div>